import { Typography, pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  border: solid ${pxToRem(1)} ${themeGet('colors.border.100')};
  border-radius: ${themeGet('borderRadius.lg')};
  transition: all 225ms ease-out;

  &:hover {
    cursor: pointer;
    border-color: ${themeGet('colors.brandPrimary.1000')};
    box-shadow: ${themeGet('dropShadow.400')};
  }
`;
export const Header = styled.div `
  display: flex;
  justify-content: space-between;
  padding: ${themeGet('spacing.xl')};
  border-bottom: solid ${pxToRem(1)} ${themeGet('colors.border.100')};
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  height: ${pxToRem(88)};

  background-image: ${props => `url(${props.$svg})`};
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;
export const Content = styled.div `
  display: flex;
  flex-direction: column;
  padding: ${themeGet('spacing.xl')};
`;
export const StyledTypography = styled(Typography) `
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: ${pxToRem(40)};
`;
export const MetaContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: ${themeGet('spacing.md')};
`;
export const FlagsContainer = styled.div `
  display: flex;
  align-items: center;
  gap: ${themeGet('spacing.sm')};
`;
